module.exports = __webpack_public_path__ + "img/construct-badge.84d5d3f2.png";